// extracted by mini-css-extract-plugin
export default {"title":"projectDocuments_title__+4bHT","documentsList":"projectDocuments_documentsList__FjRav","buttonTop":"projectDocuments_buttonTop__o4lix"};